import { useMutation, useQuery, useQueryClient } from "react-query";
import qs from "qs-lite";
import api from "../../utils/api";
import { clearCachedItem } from "../../helpers";
import { useHubSnackBar } from "../useSnackBar";
import { invalidate } from "../../helpers/clientHelper";

const REPORTS = "/reports";

const getAllReportData = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${REPORTS}?${queryString}`);
};
export const useGetAllReportData = ({ defaultLocation, enabled }) => {
  const query = new URLSearchParams(window.location.search);
  const locationId = query.get("location") || defaultLocation;

  return useQuery([REPORTS, { locationId }], getAllReportData, {
    enabled: enabled && !!locationId,
  });
};

const postCreateReport = (payload) => api.post(REPORTS, payload);
export const usePostCreateReport = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(postCreateReport, {
    onSuccess: () => {
      invalidate(queryClient, REPORTS);
      clearCachedItem("reports");
      addSnackbarSuccess({ message: "Successfully Created Report" });
    },
  });
};
